export default __webpack_public_path__ + "img/soundcloud_hover.1b79580d096580f8d9446625a792d925.svg";